import { createFileRoute } from '@tanstack/react-router';
import { WithholdingPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/withholding')({
  component: WithholdingRoute,
});

function WithholdingRoute() {
  const { orgId } = Route.useParams();
  return <WithholdingPage orgId={orgId} />;
}
